import { REQUERT_PLANHANDLESTEP_PLANHANDLE_FAILED, GET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED,
     SET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED, CLEAR_DATA_PLANHANDLESTEP_PLANHANDLE ,GET_DATA_HISTORY_SUCCEEDED, GET_DATA_STATUS_ACTION_HISTORY_SUCCEEDED} from '../actions/actionTypes'

export const planHandleStepReducer = (DataPlanHandleStep = [], actions) => {
    switch (actions.type) {
        case CLEAR_DATA_PLANHANDLESTEP_PLANHANDLE:
            {
                return {...DataPlanHandleStep,DataPlanHandleStep: []};
            }
        case GET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED:
            if(Object.keys(actions.DataPlanHandleStep).length > 0)
            {
                return {...DataPlanHandleStep,DataPlanHandleStep: actions.DataPlanHandleStep};
            }
            else
            {
                return {...DataPlanHandleStep,DataPlanHandleStep: []};
            }
        case REQUERT_PLANHANDLESTEP_PLANHANDLE_FAILED:
            return {...DataPlanHandleStep,DataPlanHandleStep: []};
        default:
            return DataPlanHandleStep;
    }
}

export const planHandleStepHandleStaffReducer = (DataHandleStaff = [], actions) => {
    switch (actions.type) {
        case SET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED:
            if(Object.keys(actions.DataHandleStaff).length > 0)
            {
                return {...DataHandleStaff,DataHandleStaff: actions.DataHandleStaff};
            }
            else
            {
                return {...DataHandleStaff,DataHandleStaff: []};
            }
        default:
            return {...DataHandleStaff,DataHandleStaff: []};
    }
}

export const HistoryReducer = (DataHistory = [], actions) => {
    switch (actions.type) {
        case GET_DATA_HISTORY_SUCCEEDED:
            if(Object.keys(actions.DataHistory).length > 0)
            {
                return {...DataHistory,DataHistory: actions.DataHistory};
            }
            else
            {
                return {...DataHistory,DataHistory: []};
            }
        default:
            return {...DataHistory};
    }
}

export const Status_ActionHistory = (StatusActionHistory = [], actions) => {
    switch (actions.type) {
        case GET_DATA_STATUS_ACTION_HISTORY_SUCCEEDED:

            if(Object.keys(actions.StatusActionHistory).length > 0)
            {
                return {...StatusActionHistory,StatusActionHistory: actions.StatusActionHistory};
            }
            else
            {
                return {...StatusActionHistory,StatusActionHistory: []};
            }
        default:
            return {...StatusActionHistory};
    }
}
